import { render, staticRenderFns } from "./ParticipantTray.vue?vue&type=template&id=4da8bf46"
import script from "./ParticipantTray.vue?vue&type=script&lang=js"
export * from "./ParticipantTray.vue?vue&type=script&lang=js"
import style0 from "./ParticipantTray.vue?vue&type=style&index=0&id=4da8bf46&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports